module.exports = __webpack_public_path__ + "static/media/36.98f8806c.mp3";